import { gql, useMutation } from '@apollo/client';
import { useAuth } from '../auth/useAuth';
import { UNWAITLIST_LEARNING_ACTIVITY_ERROR } from '../../common/rumMetrics';
import { useLogger } from '@amzn/xb-hooks';

export const UNWAITLIST_LEARNING_ACTIVITY = gql`
    mutation unwaitlistLearningActivity($userId: ID!, $learningActivityId: ID!) {
        unwaitlistLearningActivity(userId: $userId, learningActivityId: $learningActivityId) {
            id
            registrationStatus
        }
    }
`;

export const useUnwaitlistLearningActivity = (learningActivityId: string) => {
    const { log, count } = useLogger();
    const { user } = useAuth();
    return useMutation(UNWAITLIST_LEARNING_ACTIVITY, {
        variables: { userId: user.id, learningActivityId: learningActivityId },
        onError: (error) => {
            log.error('Error unwaitlisting learning activity', error);
            count(UNWAITLIST_LEARNING_ACTIVITY_ERROR);
        },
    });
};
